export function formatApiDetail(detail: unknown, status?: number): string {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item: { msg?: string }) => item?.msg)
      .filter((msg): msg is string => !!msg)
      .join(". ");
  }
  if (detail && typeof detail === "object" && "code" in detail) {
    const code = (detail as { code?: unknown }).code;
    if (typeof code === "string" && code !== "") return code;
  }
  if (status != null) return `Request failed (${status})`;
  return "Request failed";
}

export async function readApiDetail(error: unknown): Promise<string> {
  const response = (error as { response?: Response })?.response;
  if (!response) return "Request failed";

  try {
    const data = await response.clone().json();
    return formatApiDetail(data?.detail, response.status);
  } catch {
    return `Request failed (${response.status})`;
  }
}
